import { Executor, ExecutorSchema, ZodDate } from '@40seas/entities/common';
import { z } from 'zod';

export const TenantlessBaseEntitySchema = z.object({
    id: z.string().regex(/^[0-9a-f]{24}$/i),
    createdAt: ZodDate.optional().openapi({ format: 'date-time', type: 'string', description: 'Creation timestamp' }),
    updatedAt: ZodDate.optional().openapi({ format: 'date-time', type: 'string', description: 'Update timestamp' }),
    createdBy: ExecutorSchema.optional(),
});

export const WithTenantlessBaseEntitySchema = <T extends { merge: (a: unknown) => T }>(schema: T): T =>
    schema.merge(TenantlessBaseEntitySchema);

export interface TenantlessBaseEntity {
    id: string;
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: Executor;
}

export const TenantlessBaseEntityFieldsArray: (keyof TenantlessBaseEntity)[] = ['id', 'createdAt', 'updatedAt', 'createdBy'];
